// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2nowW","errorLogs":"styles_errorLogs__lYkAH"};